import ApiOptions from "./Settings/Options/ApiOptions";
import ModuleOptions from "./Settings/Options/ModuleOptions";
import OptionService from "@/services/OptionService";

export default {
  namespaced: true,
  state: () => ({
    option: {},
    optionType: {},
    inputClasses: [],
    optionTypes: {
      apiType: "Api",
      modulesType: "Modules",
      pluginsType: "Plugins",
    },
  }),
  getters: {
    optionStore: (state) => (method = "") => {
      const activeOptionType = state.optionType;
      let optionStore = "";

      if (activeOptionType.optionType == state.optionTypes.apiType) {
        optionStore = "Option/ApiOptions/";
      } else if (activeOptionType.optionType == state.optionTypes.modulesType) {
        optionStore = "Option/ModuleOptions/";
      } else if (activeOptionType.optionType == state.optionTypes.pluginsType) {
        optionStore = "Option/PluginOptions/";
      }

      return optionStore + method;
    },
  },
  mutations: {
    setOption: (state, option) => {
      state.option = option;
    },
    setOptionType: (state, optionType) => {
      state.optionType = optionType;
    },
    setInputClasses: (state, data) => {
      state.inputClasses = data;
    },
  },
  actions: {
    getInputClasses: ({ commit }) => {
      return new Promise((resolve, reject) => {
        return OptionService.inputClasses()
          .then((res) => {
            if (res.status === 200) {
              commit("setInputClasses", res.data);
            }
            resolve(res);
          })
          .catch((err) => reject(err));
      });
    },
  },
  modules: {
    ApiOptions: ApiOptions,
    ModuleOptions: ModuleOptions,
  },
};
